export const getMinSalaryValue = ({ salary, defaultValue }) => {
  if (salary && salary[0]) {
    return salary[0]?.value;
  }

  return defaultValue;
};

export const getMaxSalaryValue = ({ salary, defaultValue }) => {
  if (salary && salary[1]) {
    return salary[1]?.value;
  }

  return defaultValue;
};
